if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        if (this.form.querySelector('[name=id]')) {
          this.form.querySelector('[name=id]').disabled = false;
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.sizeSwatch = this.querySelectorAll('input[data-quick-add="true"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        if (this.sizeSwatch) {
          this.sizeSwatch.forEach((el) => {
            el.addEventListener('click', () => setTimeout(() => this.submitButton.click(), 1000));
          });
        }

        this.getNewProductTrigger = this.closest('.product-card')?.querySelectorAll('.getNewProductTrigger');
        if(this.getNewProductTrigger) {
          this.getNewProductTrigger.forEach((el) => {
            el.addEventListener('click', (event) => {
              event.preventDefault();
              this.getNewProduct(el.dataset.route, el.dataset.product);
            });
            el.addEventListener('mouseenter', (event) => {            
              event.preventDefault();
              this.getNewProduct(el.dataset.route, el.dataset.product);
            });
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').removeAttribute('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const formDataValues = [...formData.entries()];

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            this.cart.renderContents(response);
            console.log(response);
            this.submitButton.querySelector('span').textContent = 'Added to Cart';
            if (this.closest('.product-card')) {
              this.closest('.product-card').classList.add('item-added');
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally((response) => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').setAttribute('hidden', '');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // Switch product content on color swatch click
      async getNewProduct(route, el) {
        // --- loading on ---
        const btn = this?.submitButton || this?.querySelector?.('[type="submit"], .btn, .button');
        const spinner = this?.querySelector?.('.loading-overlay__spinner');
        btn?.classList.add('loading');
        btn?.setAttribute?.('aria-busy', 'true');
        btn?.setAttribute?.('disabled', '');
        spinner?.removeAttribute?.('hidden');

        const isSelector = el?.startsWith('#') || el?.startsWith('.');
        const findInDoc = (doc) => (isSelector ? doc.querySelector(el) : doc.getElementById(el));

        const absolutize = (href, base) => {
          try { return new URL(href, base).href; } catch { return null; }
        };

        const fetchPage = async (url, visited = new Set(), hop = 1) => {
          if (!url || visited.has(url)) return null;
          visited.add(url);

          const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!res.ok) throw new Error(`HTTP ${res.status} @ ${url}`);
          const html = await res.text();

          const doc = new DOMParser().parseFromString(html, 'text/html');
          const found = findInDoc(doc);
          if (found) return found;

          // next link
          let nextHref =
            doc.querySelector('link[rel="next"]')?.getAttribute('href') ||
            doc.querySelector('a[rel="next"]')?.getAttribute('href') ||
            doc.querySelector('.pagination__next, .next, a.pagination-next')?.getAttribute('href') ||
            null;

          if (nextHref) {
            const nextAbs = absolutize(nextHref, url);
            if (nextAbs && !visited.has(nextAbs)) return fetchPage(nextAbs, visited, hop + 1);
          }

          // fallback ?page=
          try {
            const u = new URL(url, window.location.origin);
            const current = parseInt(u.searchParams.get('page') || '1', 10);
            if (!Number.isNaN(current)) {
              u.searchParams.set('page', String(current + 1));
              const candidate = u.href;
              if (!visited.has(candidate)) return fetchPage(candidate, visited, hop + 1);
            }
          } catch {}

          return null;
        };

        try {
          const product = await fetchPage(route);
          if (!product) {
            console.warn('[getNewProduct] Element not found across paginated pages:', { route, el });
            return;
          }

          const card = this?.closest ? this.closest('.product-card') : null;
          if (!card) {
            console.error('[getNewProduct] Could not find ancestor .product-card to replace.');
            return;
          }

          const imported = document.importNode(product, true);
          card.replaceWith(imported);
          console.log('[getNewProduct] Replaced .product-card with fetched product.');
          // --- loading off ---
          btn?.classList.remove('loading');
          btn?.removeAttribute?.('aria-busy');
          btn?.removeAttribute?.('disabled');
          spinner?.setAttribute?.('hidden', '');
        } catch (err) {
          console.warn('[getNewProduct] Something went wrong:', err);
        }
      }
    }
  );
}
